import React from 'react';
import { styled } from 'styled-components';
import { times } from '../../../../../play-core/utils/times';
import { NowArrow } from '../NowArrow';
import { TimelineMarker } from '../TimelineMarker';
import { gridChannelWidth, gridGap, gridTimelineHeight, minutesPerDay, roundTo, timelineRightSpace } from '../tv-guide-types';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GridTimeMarkers = ({
  pixelsPerMinute,
  timelineIntervalInMin,
  programs = [],
  now
}) => {
  const interval = Math.max(roundTo(timelineIntervalInMin, 5), 5);
  const markerCount = minutesPerDay / interval + 1;
  return /*#__PURE__*/_jsxs(Layout, {
    pixelsPerMinute: pixelsPerMinute,
    children: [times(markerCount, index => /*#__PURE__*/_jsx(TimelineMarker, {
      minutes: index * interval,
      left: index * interval * pixelsPerMinute + gridChannelWidth
    }, index)), /*#__PURE__*/_jsx(SpacerRight, {
      style: {
        left: `${(markerCount - 1) * interval * pixelsPerMinute + gridChannelWidth}px`
      }
    }), programs && now && /*#__PURE__*/_jsx(NowArrow, {
      left: now,
      top: gridTimelineHeight + gridGap
    })]
  });
};
const Layout = styled.div.withConfig({
  displayName: "GridTimeMarkers__Layout",
  componentId: "sc-dfj4dy-0"
})(["display:flex;width:", "px;height:", "px;position:relative;"], ({
  pixelsPerMinute
}) => gridChannelWidth + minutesPerDay * pixelsPerMinute + timelineRightSpace, gridTimelineHeight);
const SpacerRight = styled.div.withConfig({
  displayName: "GridTimeMarkers__SpacerRight",
  componentId: "sc-dfj4dy-1"
})(["width:", "px;height:10px;position:absolute;"], timelineRightSpace);